var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_12771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.29 21.7546C23.13 21.7546 22.97 21.6946 22.84 21.5946L18.66 18.1146C18.56 18.0346 18.44 17.9846 18.31 17.9846H8.23997C7.15997 17.9846 6.27997 17.1046 6.27997 16.0246V12.9646H5.69997C5.56997 12.9646 5.44997 13.0146 5.34997 13.0946L1.16997 16.5746C0.959972 16.7546 0.669972 16.7846 0.419972 16.6746C0.169972 16.5546 0.00997209 16.3146 0.00997209 16.0346V2.22465C-2.79117e-05 1.14465 0.879972 0.264648 1.95997 0.264648H15.76C16.84 0.264648 17.72 1.14465 17.72 2.22465V5.28465H22.03C23.11 5.28465 23.99 6.16465 23.99 7.24465V21.0446C23.99 21.3146 23.83 21.5646 23.58 21.6846C23.48 21.7346 23.38 21.7546 23.28 21.7546H23.29ZM7.68997 12.9746V16.0346C7.68997 16.3346 7.93997 16.5846 8.23997 16.5846H18.31C18.77 16.5846 19.21 16.7446 19.56 17.0346L22.59 19.5446V7.24465C22.59 6.94465 22.34 6.69465 22.04 6.69465H17.73V11.0046C17.73 12.0846 16.85 12.9646 15.77 12.9646H7.68997V12.9746ZM1.95997 1.67465C1.65997 1.67465 1.40997 1.92465 1.40997 2.22465V14.5246L4.43997 12.0146C4.78997 11.7246 5.23997 11.5646 5.68997 11.5646H15.76C16.06 11.5646 16.31 11.3146 16.31 11.0146V2.22465C16.31 1.92465 16.06 1.67465 15.76 1.67465H1.95997Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_12771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.49,
    fill: "white",
    transform: "translate(0 0.264648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatScreenIcon);
export default __webpack_public_path__ + "static/media/chatScreenIcon.10befa2c2880564b1d12ee421b635124.svg";
export { ForwardRef as ReactComponent };